// extracted by mini-css-extract-plugin
export default {"doc-page-wrapper":"d_n container-lg d-flex p-3","doc-page":"d_p","doc-page__title--enterprise":"d_q","doc-page--with-side-menu":"d_r","doc-page__title":"d_s"};